// Central SEO title/description builder: "type werken in locatie? belofte | Max Q"
const BRAND = ' | Max Q';
const REVIEWS = '★ 4,8/5 op Google (39 reviews)';

const QUESTION_OVERRIDES = {
  'Renovaties & Verbouwingen': 'Renoveren of verbouwen',
  'Badkamer Renoveren': 'Badkamer renoveren',
  'Keuken Renoveren': 'Keuken renoveren',
  'Verbouwing': 'Verbouwen',
  'Badkamerspecialist': 'Badkamerspecialist nodig',
  'Badkamermeubels op Maat': 'Badkamermeubel op maat',
  'Elektriciteit Renovatie': 'Elektriciteit renoveren',
  'Sanitair Renovatie': 'Sanitair renoveren',
};

const lowerFirstRest = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();

export const toQuestion = (title) => QUESTION_OVERRIDES[title] || lowerFirstRest(title);

const promise = (loc) => (loc.length > 9 ? 'Gratis offerte' : 'Gratis offerte & vaste prijs');

export const serviceTitle = (title, loc = 'Limburg') => `${toQuestion(title)} in ${loc}? ${promise(loc)}${BRAND}`;

export const serviceDescription = (title, loc, extra = '') => {
  const where = loc ? `in ${loc}` : 'in heel Limburg';
  return `${title} ${where} door Max Q uit Ham: eigen vakmensen, vaste prijs vooraf, premies geregeld en plaatsbezoek binnen 48u. ${extra}${REVIEWS}. Vraag uw gratis offerte aan.`.replace('  ', ' ');
};

export const PAGE_META = {
  home: {
    title: 'Renoveren in Limburg? Badkamer, keuken & totaalrenovatie | Max Q Ham',
    description: `Renovatiebedrijf uit Ham met eigen vakmensen voor badkamer, keuken en totaalrenovatie in heel Limburg. Vaste prijs vooraf, premies geregeld, plaatsbezoek binnen 48u. ${REVIEWS}. Gratis offerte.`,
  },
  renoveren: {
    title: 'Renoveren in Limburg? Vaste prijs & eigen vakmensen | Max Q Ham',
    description: `Badkamer, keuken of totaalrenovatie in Limburg laten uitvoeren? Max Q uit Ham werkt met eigen vakmensen, vaste prijs vooraf en regelt uw premies. ${REVIEWS}. Gratis plaatsbezoek binnen 48u.`,
  },
  projecten: {
    title: 'Renovatie-inspiratie in Limburg? 86+ echte projectfoto\'s | Max Q',
    description: 'Bekijk gerealiseerde badkamers, keukens en totaalrenovaties van Max Q in Limburg. Echte foto\'s, geen stockbeelden. Zo kan uw renovatie er ook uitzien — vraag een gratis offerte aan.',
  },
  contact: {
    title: 'Gratis offerte of plaatsbezoek in Limburg? Binnen 48u | Max Q Ham',
    description: 'Bel +32 488 15 20 28 of vraag online uw gratis offerte aan. Plaatsbezoek binnen 48u in heel Limburg, antwoord binnen 24u. Max Q, renovatiebedrijf uit Ham met eigen vakmensen.',
  },
  calculator: {
    title: 'Wat kost uw renovatie in Limburg? Bereken het in 30 sec | Max Q',
    description: 'Gratis prijscalculator: directe prijsindicatie voor uw badkamer, keuken of totaalrenovatie in Limburg. Geen e-mail nodig. Daarna gratis offerte op maat van Max Q uit Ham.',
  },
  premies: {
    title: 'Renovatiepremies 2026 in Vlaanderen? Gids + gratis premieadvies | Max Q',
    description: 'Mijn VerbouwPremie 2026 en renovatieplicht EPC helder uitgelegd: bedragen per inkomen, voorwaarden en deadlines. Max Q regelt uw premiedossier gratis mee bij uw renovatie in Limburg.',
  },
  blog: {
    title: 'Renovatietips & premies 2026 voor Limburg | Blog van Max Q',
    description: 'Praktische renovatietips, prijzen, premies en trends van een renovatiebedrijf met 35 jaar ervaring in Limburg. Elke dag nieuw advies voor slim verbouwen in Vlaanderen.',
  },
  visualizer: {
    title: 'Hoe ziet uw renovatie eruit? Gratis AI-ontwerp in 1 minuut | Max Q',
    description: 'Upload een foto van uw badkamer, keuken, woonkamer of zolder en zie in 1 minuut een fotorealistisch renovatieontwerp. Gratis, daarna vrijblijvend uitgewerkt door Max Q uit Ham (Limburg).',
  },
  vergelijk: {
    title: 'Inloopdouche of bad? Tegels of parket? Eerlijk vergeleken | Max Q',
    description: 'Eerlijke renovatievergelijkingen met prijzen, voor- en nadelen: inloopdouche vs bad, quartz vs natuursteen, vloerverwarming vs radiatoren en meer. Door Max Q, renovaties in Limburg.',
  },
};

export const blogTitle = (title) => `${title}${BRAND}`;
